const EmergencyServiceWomen = [
	{
		id: '5201',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Fatua)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 100,
		quantity: 1
	},
	{
		id: '5202',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Fatua)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 50,
		quantity: 1
	},

	{
		id: '5203',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear ( Trouser / Slack / Pazama)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 560,
		quantity: 1
	},
	{
		id: '5204',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear ( Trouser / Slack / Pazama)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 360,
		quantity: 1
	},
	{
		id: '5205',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear ( Trouser / Slack / Pazama)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 420,
		quantity: 1
	},

	{
		id: '5206',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Lehenga (Plain / Heavy)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 680,
		quantity: 1
	},
	{
		id: '5207',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Lehenga (Plain / Heavy)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron and Fold',
		price: 380,
		quantity: 1
	},
	{
		id: '5208',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Lehenga (Plain / Heavy)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 780,
		quantity: 1
	},

	{
		id: '5209',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez / Kaftan / Apron / Tops',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 100,
		quantity: 1
	},
	{
		id: '5210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez / Kaftan / Apron / Tops',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 50,
		quantity: 1
	},
	{
		id: '5211',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez / Kaftan / Apron / Tops',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 145,
		quantity: 1
	},

	{
		id: '5212',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Plain / Fancy)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 425,
		quantity: 1
	},
	{
		id: '5213',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Plain / Fancy)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 230,
		quantity: 1
	},
	{
		id: '5214',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Plain / Fancy)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 490,
		quantity: 1
	},
	{
		id: '5215',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Silk)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 340,
		quantity: 1
	},
	{
		id: '5216',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Silk)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 190,
		quantity: 1
	},
	{
		id: '5217',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Silk)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 630,
		quantity: 1
	},
	{
		id: '5218',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Cotton)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 320,
		quantity: 1
	},
	{
		id: '5219',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Cotton)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 170,
		quantity: 1
	},
	{
		id: '5220',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Cotton)',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 380,
		quantity: 1
	},

	{
		id: '5221',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 650,
		quantity: 1
	},
	{
		id: '5222',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 270,
		quantity: 1
	},
	{
		id: '5223',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 780,
		quantity: 1
	},

	{
		id: '5224',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sweater',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 210,
		quantity: 1
	},
	{
		id: '5225',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sweater',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 90,
		quantity: 1
	},
	{
		id: '5226',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sweater',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 310,
		quantity: 1
	},
	{
		id: '5227',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Coat',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Wash and Iron',
		price: 350,
		quantity: 1
	},
	{
		id: '5228',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Coat',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 170,
		quantity: 1
	},
	{
		id: '5229',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Coat',
		category: "Women's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 370,
		quantity: 1
	}
];
export default EmergencyServiceWomen;
